import { Typography } from '@material-ui/core'
import styled from 'styled-components/macro'
import { colors } from '../../../theme.styles'

export const ButtonWrapper = styled('div')<{ $active?: boolean; $loading?: boolean }>`
  border: 2px solid ${colors.lime};
  transition: all 0.1s ease-in-out;
  min-width: 245px;
  background-color: white;
  box-sizing: border-box;
  border-radius: 15px;
  position: relative;
  display: grid;
  align-content: center;
  padding: 8px 22px 8px 12px;
  ${({ $active }) =>
    $active &&
    `
   border: 2px solid${colors.magenta};
  `}
  ${({ $loading }) =>
    $loading &&
    `
   border: 2px solid${colors.lightGrey};
  `}
`

export const Button = styled.button`
  transition: all 0.2s ease-in-out;
  border-radius: 100%;
  outline: none;
  position: relative;
  appearance: none;
  background: none;
  border: none;
  padding: 0px;
  width: auto;
  &:hover {
    box-shadow: 0px 0px 9px ${colors.lime};
  }
`

export const SlotTitle = styled(Typography)<{ $active?: boolean; $disabled?: boolean }>`
  color: ${colors.lime};
  position: absolute;
  font-weight: 600;
  font-size: 16px;
  right: 22px;
  top: 10px;
  ${({ $active }) =>
    $active &&
    `
   color: ${colors.magenta};
   `}
  ${({ $disabled }) =>
    $disabled &&
    `
   color: ${colors.lightGrey};
   
  `}
`
